import React from "react";

const FolderStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5152 5.4L9.93502 3.36571C9.69583 2.52697 8.77827 2.02922 7.88559 2.25396L3.44068 3.37301C2.54801 3.59775 2.01825 4.45987 2.25745 5.29861L3.665 10.2343C3.9042 11.073 4.82175 11.5708 5.71443 11.346L6.20001 11.2238M10.5152 5.4H7.80001C6.91636 5.4 6.20001 6.11635 6.20001 7V11.2238M10.5152 5.4H12.2C13.0837 5.4 13.8 6.11635 13.8 7V12.2C13.8 13.0837 13.0837 13.8 12.2 13.8H7.80001C6.91636 13.8 6.20001 13.0837 6.20001 12.2V11.2238",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FolderStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;